// Back-to-top button: reveal after scrolling, smooth scroll up.
customElements.define("back-to-top", class extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector("button");
    if (!this.btn) return;
    this.onScroll = () => this.classList.toggle("is-visible", window.scrollY > 600);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.btn.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
    this.onScroll();
  }
});
